import { getCounties } from './providers/gls'

export const countySuggestions = async searchVal => {
  const res = await getCounties(null, searchVal)

  const suggestionContent = res.content.map(county => {
    return {
      text: county.county_name,
      data: county.state_abbreviation,
      value: county.county_name,
      content: county.county_name,
    }
  })

  return suggestionContent
}

export const getSuggestionFetcherForField = (field, tableConfig) => {
  const definition = tableConfig.fieldDefinitions.find(
    def => def.apiRef === field
  )

  const suggestionOptions = definition.suggestionOptions || {}

  return suggestionOptions.fetcher
}
